import { useState, useCallback, useMemo } from 'react';
import { TABS_DATA } from './simpleConstants';
import { SelectionState, ExpandedItems, FAQData, TabData } from './types';

export const useFAQState = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [selectionByTab, setSelectionByTab] = useState<SelectionState>(() => {
    const initialSelections: SelectionState = {};
    TABS_DATA.forEach((tab: TabData) => {
      initialSelections[tab.value] = 0;
    });
    return initialSelections;
  });
  const [expandedItems, setExpandedItems] = useState<ExpandedItems>({});

  const handleTabChange = useCallback((event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  }, []);

  const handleQuestionClick = useCallback((index: number) => {
    setSelectionByTab((prev) => ({
      ...prev,
      [selectedTab]: index,
    }));
  }, [selectedTab]);

  const handleMobileToggle = useCallback((itemKey: string) => {
    setExpandedItems((prev) => ({
      ...prev,
      [itemKey]: !prev[itemKey],
    }));
  }, []);

  return {
    selectedTab,
    selectionByTab,
    expandedItems,
    handleTabChange,
    handleQuestionClick,
    handleMobileToggle,
  };
};


export const useFAQData = (selectedTab: number, selectionByTab: SelectionState, faqData: FAQData) => {
  const questionsForTab = useMemo(() => faqData[selectedTab] ?? [], [faqData, selectedTab]);
  const hasQuestions = useMemo(() => questionsForTab.length > 0, [questionsForTab]);
  const selectedQuestionIndex = useMemo(() => selectionByTab[selectedTab] ?? 0, [selectionByTab, selectedTab]);
  
  const activeQuestion = useMemo(() => {
    if (!hasQuestions) return null;
    return questionsForTab[selectedQuestionIndex] ?? questionsForTab[0];
  }, [hasQuestions, questionsForTab, selectedQuestionIndex]);

  const answerContent = useMemo(() => activeQuestion?.answer, [activeQuestion]);

  return {
    questionsForTab,
    hasQuestions,
    selectedQuestionIndex,
    activeQuestion,
    answerContent,
  };
};
